// Youssef Selkani
// 2019

import React, { Component, createRef } from 'react'
import {
  Container,
  Segment,
  Progress,
  Button,
  Feed,
  Grid,
  Image,
  Message,
  Embed,
  Divider,
  Placeholder,
  Visibility,
  Ref
} from 'semantic-ui-react'
import { storage } from '../../config/Fire'
import '../../App.css'
import CTA from '../../components/CTA'
import AdSense from 'react-adsense'
import avatar from '../../assets/avatar.jpg'
import phimg from '../../assets/storageph.png'
import Img from 'react-image'

const ImgLoader = (
  <Placeholder fluid style={{ height: 60, width: 60 }}>
    <Placeholder.Image />
  </Placeholder>
)
export default class StorageTuto extends Component {
  constructor (props) {
    super(props)
    this.state = {
      progress: 0,
      calculations: {
        pixelsPassed: 0
      }
    }
  }

  componentDidMount () {
    this.setState({
      winHeight: window.innerWidth
    })
  }
  handleUpdate = (e, { calculations }) => {
    this.setState({
      calculations,
      progress: ((calculations.pixelsPassed / this.state.winHeight) * 100) / 1.9
    })
  }
  contextRef = createRef()

  handleChange = (e) => {
    if (e.target.files[0]) {
      const fileobj = e.target.files[0]
      console.log(fileobj)
      this.setState(() => ({ fileobj, selected: true }))
    }
  }

  handleUpload = () => {
    this.setState({ uploading: true })
    const { fileobj } = this.state
    const uploadTask = storage.ref(`/dir/path/${fileobj.name}`).put(fileobj)
    uploadTask.on(
      'state_changed',
      (snapshot) => {
        const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100)
        this.setState({ progress })
      },
      (error) => {
        console.log(error)
        this.setState({ error: error.message + ' ' + error.code })
      },
      () => {
        storage
          .ref(`/dir/path/`)
          .child(fileobj.name)
          .getDownloadURL()
          .then((url) => {
            this.setState({ url })
          })
        this.setState({ done: true, uploading: false })
      }
    )
  }

  render () {
    let {
      fileobj,
      selected,
      uploading,
      progress,
      done,
      url,
      error,
      calculations,
      winHeight
    } = this.state
    return (
      <Ref innerRef={this.contextRef}>
        <Visibility fireOnMount onUpdate={this.handleUpdate}>
          {/* <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', zIndex: 99999 }}>
            <Progress percent={progress} color='black' size='tiny' />
          </div> */}
          <Container className='masterdiv'>
            <Grid stackable>
              <Grid.Column width='4' />
              <Grid.Column width='8'>
                <Segment padded>
                  <h1>How to upload a file to Firebase Storage in React</h1>
                  <Feed>
                    <Feed.Event>
                      <Feed.Label>
                        <Image avatar src={avatar} />
                      </Feed.Label>
                      <Feed.Content>
                        <Feed.Summary>
                          <Feed.User>Youssef Selkani</Feed.User>
                          <Feed.Date>21.12.2019</Feed.Date>
                        </Feed.Summary>
                      </Feed.Content>
                    </Feed.Event>
                  </Feed>
                </Segment>

                <Segment padded context={this.contextRef}>
                  <h3>Demo</h3>
                  <input
                    accept='image/x-png, image/jpeg'
                    id='embedpollfileinput'
                    class='inputfile'
                    type='file'
                    onChange={this.handleChange}
                  />
                  <label for='embedpollfileinput' class='ui black button basic compact'>
                    <i class='ui upload icon' />
                    Select a file
                  </label>
                  {selected && (
                    <div className='mtb'>
                      <p>{fileobj.name}</p>
                      <h5>type: {fileobj.type}</h5>
                      <h5>size: {(fileobj.size / 1024).toFixed(0)} Kb</h5>
                      <Button onClick={this.handleUpload} color='blue'>
                        Upload
                      </Button>
                    </div>
                  )}

                  {done && <Message>Uploaded successfully!</Message>}
                  {url && (
                    <div>
                      <Img
                        decode={false}
                        src={url}
                        loader={ImgLoader}
                        style={{
                          maxWidth: '60px'
                        }}
                        alt='demo-upload'
                      />
                      <br />
                      <b>Here's your download link:</b>
                      <br />
                      <a href={url}>{url}</a>
                    </div>
                  )}
                  {uploading && <Progress percent={progress} color='green' />}
                  {error && (
                    <Message negative>
                      <Message.Header>{error}</Message.Header>
                    </Message>
                  )}
                </Segment>
                <Segment padded>
                  <Embed id='St7ipgfr9EY' placeholder={phimg} source='youtube' />
                  <Divider hidden />
                  <p>
                    First, you must have a Google account, log in to{' '}
                    <a href='https://console.firebase.com'>console.firebase.com</a> then enable
                    Storage database on your account, to import and use the library on your project
                    run the command
                  </p>

                  <b>npm install firebase</b>
                  <Divider />
                  <p>
                    In a separate file initialize the app using your config credentials like
                    demonstrated below
                  </p>

                  <pre className='codeblock'>
                    {`
  import firebase from 'firebase/app'
  import 'firebase/storage'

  const config = {
    apiKey: 'xxx-xxxx',
    authDomain: 'xxx-xxx.firebaseapp.com',
    databaseURL: 'https://xxxx-xxxx.firebaseio.com',
    projectId: 'xxxxx-xxxx',
    storageBucket: 'xxxx-xxxx.appspot.com',
    messagingSenderId: 'xxxxxxx'
  }
  const fire = firebase.initializeApp(config)
  const storage = firebase.storage()

  export { storage as default } 
  `}
                  </pre>

                  <p>
                    From there, you start by building the user interface, we only need 3 components
                    to handle the upload process, the first element one is an input file picker,
                    using the accept method you can specify what file types to allow, we also give
                    it an id so we can hide the default ugly input picker.
                  </p>
                  <pre className='codeblock'>
                    {`
  {done && <h3>Uploaded successfully!</h3>}
  {uploading && <progress percent={progress}  />}
    ...
  <input
    accept='image/x-png, image/jpeg'
    id='myfileinput'
    class='inputfile'
    type='file'
    onChange={this.handleChange}
    />

    <label for='myfileinput'>
    <i class='ui upload icon' />
    Select a file
    </label>

    <button 
    onClick={this.handleUpload}>
    Upload
    </button>

  `}
                  </pre>
                  <p>
                    The handleChange function only return the file selected by the user and save it
                    to the state, note that we are only using the first file selected, as you know,
                    the input can also accept multiple files selecttion, in that case, tweak your
                    code accordingly to make sure you are handling all selected files.
                  </p>

                  <pre className='codeblock'>
                    {`
  handleChange = (e) => {
    if (e.target.files[0]) {
      const fileobj = e.target.files[0]
      this.setState(() => ({ fileobj, selected: true }))
    }
  }

`}
                  </pre>

                  <p>
                    To upload the file to Firebase, we used a button to trigger the function for
                    demonstration purpose but you can also do it on file select so you get rid of
                    one additional step, we then setState a loading variable and provide{' '}
                    <b>storage.ref</b> with a valid <b>path</b> and send it using{' '}
                    <b>.put(fileobj)</b>
                  </p>

                  <p>
                    For better user experience we display a progress bar, to calculate the
                    percentage of the upload it's quite easy, all you got to do is: bytesTransferred
                    / totalBytes by 100. The <b>snapshot</b> variable is the object/file we are
                    uploading.
                  </p>

                  <pre className='codeblock'>
                    {`
  handleUpload = () => {
    this.setState({ uploading: true })
    const { fileobj } = this.state
    const uploadTask = storage.ref('/dir/path').put(fileobj)
    uploadTask.on(
      'state_changed',
      (snapshot) => {
        const progress = 
        Math.round((snapshot.bytesTransferred / 
        snapshot.totalBytes) * 100)
        this.setState({ progress })
      },
      (error) => {
        console.log(error)
      },
      () => {
        console.log('200 OK')
        this.setState({ done: true, uploading: false })
      }
    )
  }

`}
                  </pre>

                  <p>
                    Finally we make sure to catch <b>errors</b> and update state variables in a
                    callback. At this point you can pull the download url for file but I decided to
                    put it in componentDidMount for the sake of simplicty.
                  </p>
                  <pre className='codeblock'>
                    {`
  componentDidMount = () => {
      storage
      .ref('/dir/path/')
      // .child('inCaseYouLookinForSpecificFile')
      .getDownloadURL()
      .then((url) => {
        this.setState({ url })
      })
    }

`}
                  </pre>
                  <p>Hope you learned something valuable today! Thanks for reading.</p>
                  <AdSense.Google
                    client='ca-pub-8573101599140905'
                    slot='2309113111'
                    style={{ display: 'block' }}
                    format='fluid'
                    layoutKey='-fb+5w+4e-db+86'
                  />
                </Segment>
              </Grid.Column>
              <Grid.Column width='4' />
            </Grid>
          </Container>
        </Visibility>
      </Ref>
    )
  }
}
